<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="data.model.infraestruturas"
        >
            <template v-slot:cell(modulos)="{item}">
                {{ item.modulos.map(modulo => modulo.nome).join(', ') }}
            </template>

            <template v-slot:cell(actions)="{index, item}">
                <rkm-button
                    @click="$refs.Modal.edit(item)"
                    color="primary"
                    small
                    title="Editar"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    @click="destroy(index)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <Modal
            :data="data"
            ref="Modal"
        />
    </div>
</template>

<script>
// Components.
import Modal from './Modal.vue'

export default {
    components: {Modal},
    data: () => ({
        fields: [
            {key: 'unidadeNomeFantasia', label: 'Unidade'},
            {key: 'nome', label: 'Local de atendimento'},
            {key: 'modulos', label: 'Módulos'},
            {class: 'col-min text-center', key: 'actions', label: 'Ações'},
        ],
    }),
    methods: {
        destroy(index) {
            this.showDeleteConfirmation('Deseja realmente excluir o local de atendimento?', async () => {
                this.data.model.infraestruturas.splice(index, 1)
            })
        },
    },
    props: {
        data: {type: Object, required: true},
    },
}
</script>